import {
  Spacing
} from 'UI'

export default theme => ({
  container: {
    padding: () => Spacing(5),
    backgroundColor: theme.neutral[400],
    borderTop: `1px solid ${theme.neutral[0]}`,
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    bottom: 0,
    width: '100%',
    zIndex: 4200
  },
  buttonClass: {
    flexDirection: 'row-reverse'
  }
})
